import { Link } from "react-router-dom";
import { TID } from "@/constants/testIds";

export default function ArtworkCard({ artwork, priority = "medium" }) {
  return (
    <Link
      to={`/artwork/${artwork.id}`}
      data-testid={TID.artworkCard(artwork.id)}
      className="group block relative"
    >
      <div
        className="relative overflow-hidden bg-[hsl(var(--bg-secondary))] flex items-center justify-center"
        style={{ aspectRatio: "4/5" }}
      >
        <img
          src={artwork.image_url}
          alt={`${artwork.title} — ${artwork.medium} by Colin Darke, ${artwork.year}`}
          loading={priority === "high" ? "eager" : "lazy"}
          className="max-w-full max-h-full w-auto h-auto object-contain transition-transform duration-[900ms] ease-out group-hover:scale-[1.02]"
        />
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-[hsl(var(--ink))]/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500 pointer-events-none">
          <p className="catalog-label text-[hsl(var(--bg))]/85">
            {artwork.category} · {artwork.year}
          </p>
          <h3 className="font-serif text-2xl text-[hsl(var(--bg))] mt-1">
            {artwork.title}
          </h3>
        </div>
        {artwork.availability === "Sold" && (
          <div className="absolute top-4 left-4 catalog-label bg-[hsl(var(--ink))] text-[hsl(var(--bg))] px-2 py-1">
            Sold
          </div>
        )}
      </div>
      <div className="mt-4 flex items-baseline justify-between gap-4">
        <div>
          <h3 className="font-serif text-xl leading-tight">{artwork.title}</h3>
          <p className="catalog-label mt-1">
            {artwork.medium} · {artwork.dimensions}
          </p>
        </div>
        <span className="catalog-label text-[hsl(var(--vermillion))] whitespace-nowrap">
          {artwork.availability}
        </span>
      </div>
    </Link>
  );
}
